import Vue from 'vue'
import VueRouter from 'vue-router'
import home from './routes/home'
import news from './routes/news'
import userCenter from '@/router/routes/userCenter';

import { Message } from 'element-ui'
import base from '@/utils/js/base';
import store from '@/store';
import * as type from '@/store/mutation-types';
import { getAgentTypeById, querySourceMaintain, synchronizeUser,getRoleMenu,queryConstantOptimizeInfo } from '@/apis/home/user';
import { getLoginInfo } from '@/apis/userCenter/userCenter';

Vue.use(VueRouter)

// 解决 NavigationDuplicated: Avoided redundant navigation to current location 报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    redirect: '/homePage'
  },
  ...home,
  ...userCenter,
  ...news,
]

const router = new VueRouter({
  routes,
  mode: 'history'
});

const setTitle = (title='商标专利交易中心') => {
  document.title = title
  document.head.querySelector('title').innerText = title
};

const COMMON_PARAMS = {
  "appKey":"quandashi4106565062",
  "session":"",
  "format":"json",
  "partnerId":"",
  "targetAppKey":"",
  "signMethod":"md5",
  "executor":"140fcf1dfb9b6368d33e1d16d14fcad3",
  "v":"1.0",
  "inputType":1,
};

const goLogin = () => {
  let info = {
    agentOrWriter: '',
    operatorId: "",
    operatorName: "",
    userId: "",
    userImg: "",
    userName: ""
  }
  store.commit('userInfo/setHasLoginInfo', false);
  store.commit('userInfo/setLoginInfoOffice', info);
  store.commit('userInfo/setRolePermissionList', []);

  store.commit('userInfo/setAgentType', -1);
  store.commit('userInfo/setPartnerType', -1);
  store.commit('userInfo/setPayStatus', -1);
  store.commit('userInfo/setInteriorStatus', -1);
  store.commit('userInfo/setAccountType', -1);
  store.commit('userInfo/setBuiltinType', -1);

  localStorage.removeItem('wxzcTokenValue');
  localStorage.removeItem('wxzcTokenName');
  localStorage.removeItem('userId');
  localStorage.removeItem('QDS_LOGIN_INFO_OFFICE_'+document.domain);
  localStorage.removeItem('QDS_AGENT_ORGAN_INFO_'+document.domain);
  let clearUserIdentity = {
    agentType: 0,
    avatar: '',
    userName: '',
    userType: 0
  };
  store.commit(`common/${type.SET_USER_IDENTITY}`, clearUserIdentity);
  base.clearCookie('QDS_LOGIN_INFO_OFFICE_'+document.domain);
  base.clearCookie('QDS_AGENT_ORGAN_INFO_'+document.domain);
  base.clearCookie('QDS_COOKIE_'+document.domain);

  if(router.history.current.path!='/' && router.history.current.path!='/login'){
    sessionStorage.setItem('qdsHistoryUserId',store.state.userInfo.QDS_LOGIN_INFO_OFFICE.userId);
    sessionStorage.setItem('qdsHistoryRoutePath',router.history.current.path);
    sessionStorage.setItem('qdsHistoryRouteQuery',JSON.stringify(router.history.current.query));
  }
  router.push({path: '/login'});
};

function initLoginInfo() {
  let info = {
    agentOrWriter: '',
    operatorId: "",
    operatorName: "",
    userId: "",
    userImg: "",
    userName: ""
  }
  store.commit('userInfo/setHasLoginInfo', false);

  store.commit('userInfo/setAgentType', -1);
  store.commit('userInfo/setPartnerType', -1);
  store.commit('userInfo/setPayStatus', -1);
  store.commit('userInfo/setInteriorStatus', -1);
  store.commit('userInfo/setAccountType', -1);
  store.commit('userInfo/setBuiltinType', -1);

  store.commit('userInfo/setLoginInfoOffice', info);
  localStorage.removeItem('wxzcTokenValue');
  localStorage.removeItem('wxzcTokenName');
  localStorage.removeItem('userId');
  localStorage.removeItem('QDS_LOGIN_INFO_OFFICE_'+document.domain);
  localStorage.removeItem('QDS_AGENT_ORGAN_INFO_'+document.domain);
  let clearUserIdentity = {
    agentType: 0,
    avatar: '',
    userName: '',
    userType: 0
  };
  store.commit(`common/${type.SET_USER_IDENTITY}`, clearUserIdentity);
  store.commit('userInfo/setRolePermissionList', []);
  base.clearCookie('QDS_LOGIN_INFO_OFFICE_'+document.domain);
  base.clearCookie('QDS_AGENT_ORGAN_INFO_'+document.domain);
  base.clearCookie('QDS_COOKIE_'+document.domain);
}

async function getLoginInfoByToken(token,source,userType) {
  let {code,subCode,data,subMessage} = await getLoginInfo({tokenValue: token});
  if(code==9091 && subCode==10002){
    base.localStorageSet("wxzcTokenValue", data.tokenValue);//将token存储起来
    base.localStorageSet("wxzcTokenName", data.tokenName);//将token存储起来
    let QDS_LOGIN_INFO_OFFICE = {
      operatorId: '',
      operatorName: '',
      userId: data.userId,
      userName: data.userName,
      userImg: '',
      agentOrWriter: '',
    }
    let QDS_AGENT_ORGAN_INFO = {
      agentIde: data.userId,
      account: data.userPhone,
      agentName: '',
      agentOrganId: '',
      agentOrganName: '',
    }
    base.setCookie('QDS_LOGIN_INFO_OFFICE_'+document.domain, encodeURIComponent(JSON.stringify(QDS_LOGIN_INFO_OFFICE)));
    base.setCookie('QDS_AGENT_ORGAN_INFO_'+document.domain, encodeURIComponent(JSON.stringify(QDS_AGENT_ORGAN_INFO)));
    localStorage.setItem('QDS_LOGIN_INFO_OFFICE_'+document.domain, encodeURIComponent(JSON.stringify(QDS_LOGIN_INFO_OFFICE)));
    localStorage.setItem('QDS_AGENT_ORGAN_INFO_'+document.domain, encodeURIComponent(JSON.stringify(QDS_AGENT_ORGAN_INFO)));

    // TODO 获取功能权限及角色
    // 缓存角色
    getRoleMenu({userIdStr: data.userId,source: source, roleType: userType}).then(req=>{
      if(req.code=='00000'){
        store.commit('userInfo/setRolePermissionList', req.data.menuList); // 角色功能
      } else {
        if(req.subCode == 10001 && req.subMessage.indexOf('token')>-1){
          window.parent.postMessage("logout", "*");
        }
        initLoginInfo();
        router.push('/login');
        return;
      }
    })
    
  } else {
    if(subCode == 10001 && subMessage.indexOf('token')>-1){
      window.parent.postMessage("logout", "*");
    }
    initLoginInfo();
    router.push('/login');
    return;
  }
}


/**
 * 这里的逻辑1. 头部信息那未读数据和合伙人接口每个页面都调用； 2. 除首页外其他页面需要进行登录校验
 */
router.beforeEach(async (to, from, next) => {
  if (to && to.meta && to.meta.name) {
    setTitle(to.meta.name);
  } else {
    setTitle();
  }

  let passRoutes = ['/homePage','/login', '/agreementDetail','/news']; // 定义不过校验的路由

  store.commit('userInfo/setCurrentRoute', JSON.stringify(to));

  if((to.path == '/homePage') && JSON.stringify(to.query)!='{}' && to.query.qdsToken){
    await getLoginInfoByToken(to.query.qdsToken);
    base.localStorageSet("wxzcTokenName", "qdsToken");
  }

  let agentIde = base.getCookie('QDS_AGENT_ORGAN_INFO_'+document.domain) || localStorage.getItem('QDS_AGENT_ORGAN_INFO_'+document.domain);
  let decodeAgentInfo = decodeURIComponent(agentIde);
  let parseAgentInfo = (decodeAgentInfo != 'undefined' && decodeAgentInfo != '') ? JSON.parse(decodeAgentInfo) : {};

  let loginInfo = base.getCookie('QDS_LOGIN_INFO_OFFICE_'+document.domain) || localStorage.getItem('QDS_LOGIN_INFO_OFFICE_'+document.domain);
  let deCodeLoginInfo = decodeURIComponent(loginInfo);
  let parseDeCodeLoginInfo = loginInfo && (deCodeLoginInfo != 'undefined' && deCodeLoginInfo != '') && JSON.parse(deCodeLoginInfo) || {};
  let parseLoginInfo = (deCodeLoginInfo != 'undefined' && deCodeLoginInfo != '') ? JSON.parse(deCodeLoginInfo) : {};

  if (to.path && passRoutes.includes(to.path)) {
    const tokenStr = base.localStorageGet('wxzcTokenValue')!==null;
    if (!tokenStr){
      let info = {
        agentOrWriter: '',
        operatorId: "",
        operatorName: "",
        userId: "",
        userImg: "",
        userName: ""
      }
      store.commit('userInfo/setHasLoginInfo', false);
      store.commit('userInfo/setRolePermissionList', []);

      store.commit('userInfo/setAgentType', -1);
      store.commit('userInfo/setPartnerType', -1);
      store.commit('userInfo/setPayStatus', -1);
      store.commit('userInfo/setInteriorStatus', -1);
      store.commit('userInfo/setAccountType', -1);
      store.commit('userInfo/setBuiltinType', -1);

      store.commit('userInfo/setLoginInfoOffice', info);
      next();
    } else if ((parseLoginInfo && parseLoginInfo.userId)) {
      // 存在存储用户登录信息
      store.commit('userInfo/setHasLoginInfo', true);
      store.commit('userInfo/setAgentInfo', parseAgentInfo);
      synchronizeUser({
        userIdStr: parseLoginInfo.userId,
        roleType: null,
        source: 1
      }).then(res => {
        if(res.code === '00000'){
          if(res.data && res.data.userName) {
            // 缓存角色
            getRoleMenu({userIdStr: parseLoginInfo.userId,source: 1, roleType: null,}).then(req1=>{
              if(req1.code=='00000'){
                store.commit('userInfo/setRolePermissionList', req1.data.menuList); // 角色功能
              } else {
                if(req1.subCode == 10001 && req1.subMessage.indexOf('token')>-1){
                  window.parent.postMessage("logout", "*");
                }
                initLoginInfo();
                router.push('/login');
                return;
              }
            })
            // 判断是否灰度账号
            queryConstantOptimizeInfo({appKey: 'quandashi4106565062',signMethod: 'md5',inputType: 1,
            v: '1.0',executor: "140fcf1dfb9b6368d33e1d16d14fcad3",inputType: 1,timestamp: new Date().getTime(),sign: new Date().getTime(),
            format: 'json',type: 'grayscale_phone'}).then(optRes=>{
              if(optRes.code==9091 && optRes.subCode==10002){
                if(optRes.data && optRes.data.content && optRes.data.content.indexOf(parseAgentInfo.account) > -1){
                  base.setCookie('qds_version_id', 'v2');
                } else {
                  base.clearCookie('qds_version_id');
                }
              }
            })
            
            parseDeCodeLoginInfo.userImg = res.data && res.data.avatar ? res.data.avatar : '';
            parseDeCodeLoginInfo.userName = res.data && res.data.userName ? res.data.userName : '';
            localStorage.setItem('QDS_LOGIN_INFO_OFFICE_'+document.domain, encodeURIComponent(JSON.stringify(parseDeCodeLoginInfo)));
            base.setCookie('QDS_LOGIN_INFO_OFFICE_'+document.domain, encodeURIComponent(JSON.stringify(parseDeCodeLoginInfo)));
            localStorage.setItem('QDS_AGENT_ORGAN_INFO_'+document.domain, encodeURIComponent(JSON.stringify(parseAgentInfo)));
            base.setCookie('QDS_AGENT_ORGAN_INFO_'+document.domain, encodeURIComponent(JSON.stringify(parseAgentInfo)));
            store.commit('userInfo/setLoginInfoOffice', parseDeCodeLoginInfo);

            store.commit('userInfo/setAgentType', res.data.agentType);
            store.commit('userInfo/setPartnerType', res.data.userType);
            store.commit('userInfo/setPayStatus', res.data.payStatus);
            store.commit('userInfo/setInteriorStatus', res.data.interiorStatus);
            store.commit('userInfo/setAccountType', res.data.accountType);
            store.commit('userInfo/setBuiltinType', res.data.builtinType);

            store.commit(`common/${type.SET_USER_IDENTITY}`, res.data);
            querySourceMaintain({}).then((result) => {
              if(result.code==='00000'){
                if(result.data == 0){
                  getAgentTypeById({ agentId: parseLoginInfo.userId}).then(ress => {
                    if (ress.code !== '00000') {
                      Message.error(ress.msg);
                      next();
                      return;
                    }
                    if (ress.code === '00000') {
                      if (ress.data != 1) {
                        if(window.location.href.indexOf('websiteMaintenance') > -1){return}
                        return next('/websiteMaintenance');
                      } else {
                        next();
                      }
                    }
                  })
                } else {
                  return next();
                }
              } 
            }, error => {
              initLoginInfo();
              return next('/login')
            }).catch(error => {
              initLoginInfo();
              return next('/login')
            });
            next();
          } else {
            store.commit('userInfo/setAgentType', -1);
            store.commit('userInfo/setPartnerType', -1);
            store.commit('userInfo/setPayStatus', -1);
            store.commit('userInfo/setInteriorStatus', -1);
            store.commit('userInfo/setAccountType', -1);
            store.commit('userInfo/setBuiltinType', -1);
            
            store.commit('userInfo/setRolePermissionList', []);
            next();
          }
        } else {
          next();
        }
      }, err => {
        next();
      });
    } else {
      store.commit('userInfo/setHasLoginInfo', false);
      store.commit('userInfo/setRolePermissionList', []);

      store.commit('userInfo/setAgentType', -1);
      store.commit('userInfo/setPartnerType', -1);
      store.commit('userInfo/setPayStatus', -1);
      store.commit('userInfo/setInteriorStatus', -1);
      store.commit('userInfo/setAccountType', -1);
      store.commit('userInfo/setBuiltinType', -1);
      next();
    }
  } else {
    let tokenStr = base.localStorageGet('wxzcTokenValue')!==null;
    let isLogin = store.state.userInfo.hasLoginInfo;
    if (!tokenStr){
      let info = {
        agentOrWriter: '',
        operatorId: "",
        operatorName: "",
        userId: "",
        userImg: "",
        userName: ""
      }
      store.commit('userInfo/setHasLoginInfo', false);
      store.commit('userInfo/setRolePermissionList', []);
      
      store.commit('userInfo/setAgentType', -1);
      store.commit('userInfo/setPartnerType', -1);
      store.commit('userInfo/setPayStatus', -1);
      store.commit('userInfo/setInteriorStatus', -1);
      store.commit('userInfo/setAccountType', -1);
      store.commit('userInfo/setBuiltinType', -1);
      
      store.commit('userInfo/setLoginInfoOffice', info);
      return next('/login');
    } else if (isLogin || parseLoginInfo) {
      if (parseLoginInfo) {
        store.commit('userInfo/setHasLoginInfo', true);
        store.commit('userInfo/setAgentInfo', parseAgentInfo);
        synchronizeUser({
          userIdStr: parseLoginInfo.userId,
          roleType: null,
          source: 1
        }).then(res => {
          if(res.code === '00000') {
            if(res.data && res.data.userName){
              
              // 缓存角色
              getRoleMenu({userIdStr: parseLoginInfo.userId,source: 1, roleType: null,}).then(req1=>{
                if(req1.code=='00000'){
                  store.commit('userInfo/setRolePermissionList', req1.data.menuList); // 角色功能
                } else {
                  if(req1.subCode == 10001 && req1.subMessage.indexOf('token')>-1){
                    window.parent.postMessage("logout", "*");
                  }
                  initLoginInfo();
                  router.push('/login');
                  return;
                }
              })
              // 判断是否灰度账号
              queryConstantOptimizeInfo({appKey: 'quandashi4106565062',signMethod: 'md5',inputType: 1,
              v: '1.0',executor: "140fcf1dfb9b6368d33e1d16d14fcad3",inputType: 1,timestamp: new Date().getTime(),sign: new Date().getTime(),
              format: 'json',type: 'grayscale_phone'}).then(optRes=>{
                if(optRes.code==9091 && optRes.subCode==10002){
                  if(optRes.data && optRes.data.content && optRes.data.content.indexOf(parseAgentInfo.account) > -1){
                    base.setCookie('qds_version_id', 'v2');
                  } else {
                    base.clearCookie('qds_version_id');
                  }
                }
              })

              parseDeCodeLoginInfo.userImg = res.data && res.data.avatar ? res.data.avatar : '';
              parseDeCodeLoginInfo.userName = res.data && res.data.userName ? res.data.userName : '';
              localStorage.setItem('QDS_LOGIN_INFO_OFFICE_'+document.domain, encodeURIComponent(JSON.stringify(parseDeCodeLoginInfo)));
              base.setCookie('QDS_LOGIN_INFO_OFFICE_'+document.domain, encodeURIComponent(JSON.stringify(parseDeCodeLoginInfo)));
              localStorage.setItem('QDS_AGENT_ORGAN_INFO_'+document.domain, encodeURIComponent(JSON.stringify(parseAgentInfo)));
              base.setCookie('QDS_AGENT_ORGAN_INFO_'+document.domain, encodeURIComponent(JSON.stringify(parseAgentInfo)));
              store.commit('userInfo/setLoginInfoOffice', parseDeCodeLoginInfo);
              
              store.commit('userInfo/setAgentType', res.data.agentType);
              store.commit('userInfo/setPartnerType', res.data.userType);
              store.commit('userInfo/setPayStatus', res.data.payStatus);
              store.commit('userInfo/setInteriorStatus', res.data.interiorStatus);
              store.commit('userInfo/setAccountType', res.data.accountType);
              store.commit('userInfo/setBuiltinType', res.data.builtinType);
              
              store.commit(`common/${type.SET_USER_IDENTITY}`, res.data);
              querySourceMaintain({}).then((result) => {
                if(result.code==='00000'){
                  if(result.data == 0){
                    getAgentTypeById({ agentId: parseLoginInfo.userId}).then(ress => {
                      if (ress.code !== '00000') {
                        Message.error(ress.msg);
                        next();
                        return;
                      }
                      if (ress.code === '00000') {
                        if (ress.data != 1) {
                          if(window.location.href.indexOf('websiteMaintenance') > -1){return}
                          return next('/websiteMaintenance');
                        } else {
                          next();
                        }
                      }
                    })
                  } else {
                    return next();
                  }
                } else {
                  initLoginInfo();
                  return next();
                }
              }, error => {
                initLoginInfo();
                return next('/login')
              }).catch(error => {
                initLoginInfo();
                return next('/login')
              });
            } else {
              store.commit('userInfo/setRolePermissionList', []);
              store.commit('userInfo/setAgentType', -1);
              store.commit('userInfo/setPartnerType', -1);
              store.commit('userInfo/setPayStatus', -1);
              store.commit('userInfo/setInteriorStatus', -1);
              store.commit('userInfo/setAccountType', -1);
              store.commit('userInfo/setBuiltinType', -1);
              next();
            }
          } else {
            next();
          }
        }, err => {
          next();
        });
      } else {
        store.commit('userInfo/setHasLoginInfo', false);
        store.commit('userInfo/setRolePermissionList', []);
        
        store.commit('userInfo/setAgentType', -1);
        store.commit('userInfo/setPartnerType', -1);
        store.commit('userInfo/setPayStatus', -1);
        store.commit('userInfo/setInteriorStatus', -1);
        store.commit('userInfo/setAccountType', -1);
        store.commit('userInfo/setBuiltinType', -1);
        
        sessionStorage.setItem('qdsHistoryUserId',store.state.userInfo.QDS_LOGIN_INFO_OFFICE.userId);
        sessionStorage.setItem('qdsHistoryRoutePath',router.history.pending.path ? router.history.pending.path : router.history.current.path);
        sessionStorage.setItem('qdsHistoryRouteQuery',router.history.pending.query!='{}' ? JSON.stringify(router.history.pending.query) : JSON.stringify(router.history.current.query));
        router.push({path: '/login'});
      }
    } else {
      sessionStorage.setItem('qdsHistoryUserId',store.state.userInfo.QDS_LOGIN_INFO_OFFICE.userId);
      sessionStorage.setItem('qdsHistoryRoutePath',router.history.pending.path ? router.history.pending.path : router.history.current.path);
      sessionStorage.setItem('qdsHistoryRouteQuery',router.history.pending.query!='{}' ? JSON.stringify(router.history.pending.query) : JSON.stringify(router.history.current.query));
      goLogin();
    }
  }
});

export default router;
